/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_OnlyInputs */

const en_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus period ended. Claim your rewards soon!`)
};

const ar_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهت فترة التركيز. سارع بالمطالبة بمكافآتك!`)
};

const de_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokusperiode beendet. Fordern Sie bald Ihre Belohnungen an!`)
};

const es_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El periodo de participación ha finalizado. ¡Reclama tus recompensas cuanto antes!`)
};

const fr_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période de concentration terminée. Réclamez vos récompenses sans tarder !`)
};

const it_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il periodo di concentrazione è terminato. Richiedi subito i tuoi premi!`)
};

const ja_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中期間が終了しました。報酬を受け取りましょう！`)
};

const ko_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 기간이 끝났어요. 지금 바로 리워드를 받으세요!`)
};

const pt_br_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim do período de foco. Resgate suas recompensas em breve!`)
};

const ru_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Период фокусировки завершён. Скорее заберите свои награды!`)
};

const th_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช่วงการโฟกัสสิ้นสุดลงแล้ว รับรางวัลของคุณได้เลย!`)
};

const tr_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma dönemi sona erdi. Ödüllerini al!`)
};

const zh_cn_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注累积时间已结束，请尽速领取奖励。`)
};

const zh_tw_claim_only = /** @type {(inputs: Claim_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注累積時間已結束，請儘速領取獎勵`)
};

/**
* | output |
* | --- |
* | "Focus period ended. Claim your rewards soon!" |
*
* @param {Claim_OnlyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const claim_only = /** @type {((inputs?: Claim_OnlyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_OnlyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claim_only(inputs)
	if (locale === "ar") return ar_claim_only(inputs)
	if (locale === "de") return de_claim_only(inputs)
	if (locale === "es") return es_claim_only(inputs)
	if (locale === "fr") return fr_claim_only(inputs)
	if (locale === "it") return it_claim_only(inputs)
	if (locale === "ja") return ja_claim_only(inputs)
	if (locale === "ko") return ko_claim_only(inputs)
	if (locale === "pt_br") return pt_br_claim_only(inputs)
	if (locale === "ru") return ru_claim_only(inputs)
	if (locale === "th") return th_claim_only(inputs)
	if (locale === "tr") return tr_claim_only(inputs)
	if (locale === "zh_cn") return zh_cn_claim_only(inputs)
	return zh_tw_claim_only(inputs)
});